// import { Task } from '@/components//gantt-task-react/dist/types/public-types'
import { Task } from '@/components/Gantt/gantt-task-react/dist/types/public-types'
import moment from 'moment'
import { RESULT } from '@/constant/section'
const currentDate = new Date()
function getDate(dateStr: string) {
  return dateStr ? new Date(dateStr) : currentDate
}

function getProjectColorByStatus(status: string) {
  let progressColor = 'transparent'
  let backgroundColor = 'rgba(214, 214, 214, 0.2)'
  let borderColor = '#D6D6D6'
  switch (status) {
    case RESULT.DONE_OVERDUE:
    case RESULT.IN_PROGRESS_OVERDUE:
      progressColor = '#C03261'
      break
    case RESULT.DONE_ON_TIME:
      progressColor = '#65BF73'
      break
    case RESULT.IN_PROGRESS_UPCOMING:
    case RESULT.IN_PROGRESS_PLANNED:
    case RESULT.IN_PROGRESS:
      progressColor = '#ADADAD'
      break
    default:
      progressColor = 'transparent'
      backgroundColor = 'transparent'
      break
  }
  return {
    progressColor,
    backgroundColor,
    borderColor,
  }
}

function getActualDateBarColor(status: string) {
  let color = 'transparent'
  if (status === RESULT.DONE_ON_TIME) {
    color = '#65BF73'
  }
  if (status === RESULT.DONE_OVERDUE) {
    color = '#C03261'
  }
  return color
}

function getPlanBarColor(status: string, taskColorObj: any) {
  let color = '#D6D6D6'
  if (status !== RESULT.DONE_ON_TIME && status !== RESULT.DONE_OVERDUE) {
    color = taskColorObj.borderColor
  }
  return color
}

function getColorByStatus(status: string) {
  let progressColor = 'transparent'
  let backgroundColor = '#D6D6D6'
  let borderColor = 'transparent'
  switch (status) {
    case RESULT.DONE_OVERDUE:
      progressColor = '#C03261'
      borderColor = '#C03261'
      break
    case RESULT.DONE_ON_TIME:
      progressColor = '#65BF73'
      borderColor = '#65BF73'
      break
    case RESULT.IN_PROGRESS:
      progressColor = 'rgba(74, 141, 192, 0.6)'
      borderColor = 'rgba(74, 141, 192,1)'
      backgroundColor = 'rgba(74, 141, 192, 0.6)'
      break
    case RESULT.IN_PROGRESS_OVERDUE:
      progressColor = 'rgba(192, 50, 97,0.1)'
      backgroundColor = 'rgba(192, 50, 97,0.2)'
      borderColor = 'rgba(192, 50, 97, 1)'
      break
    case RESULT.IN_PROGRESS_UPCOMING:
      progressColor = 'rgba(239, 151, 71, 0.2)'
      backgroundColor = 'rgba(239, 151, 71, 0.2)'
      borderColor = 'rgba(239, 151, 71, 1)'
      break
    case RESULT.IN_PROGRESS_PLANNED:
      progressColor = 'rgba(74, 141, 192, 0.2)'
      backgroundColor = 'rgba(74, 141, 192, 0.2)'
      borderColor = 'rgba(74, 141, 192, 1)'
      break
    case RESULT.NOT_START_NO_PLANNED:
      progressColor = 'transparent'
      backgroundColor = 'transparent'
      break
    default:
      progressColor = 'transparent'
      backgroundColor = 'transparent'
      break
  }
  return {
    progressColor,
    backgroundColor,
    borderColor,
  }
}

export function getTasks(pSections) {
  let i = 1
  const ganttTasks: Task[] = []
  if (!pSections && pSections.length <= 0) return ganttTasks
  const sections = JSON.parse(JSON.stringify(pSections))

  for (let section of sections) {
    let colorObj = getProjectColorByStatus(section.result)
    let project: Task = {
      start: getDate(section.plan_start_date),
      end: getDate(section.plan_end_date),
      name: section.name,
      id: section.id,
      progress: section.progress,
      type: 'project',
      totalTask: section.tasks ? section.tasks.length : 0,
      totalCompletedTask: 0,
      displayOrder: i,
      hideChildren: true,
      status: section.result,
      styles: {
        backgroundColor: colorObj.backgroundColor,
        progressColor: colorObj.progressColor,
        borderColor: colorObj.borderColor,
        backgroundSelectedColor: colorObj.backgroundColor,
        progressSelectedColor: colorObj.progressColor,
      },
    }

    ganttTasks.push(project)

    if (section.tasks) {
      let doneTask = 0

      for (let task of section.tasks) {
        let isTaskDone = false
        if (
          task.result === RESULT.DONE_ON_TIME ||
          task.result === RESULT.DONE_OVERDUE
        ) {
          isTaskDone = true
          doneTask++
        }
        let planStartDate = task.plan_start_date
        let planEndDate = task.plan_end_date
        let taskColorObj = getColorByStatus(task.result)
        let styles = {
          progressColor: taskColorObj.progressColor,
          progressSelectedColor: taskColorObj.progressColor,
          backgroundSelectedColor: colorObj.backgroundColor,
          backgroundColor: taskColorObj.backgroundColor,
          borderColor: getPlanBarColor(task.result, taskColorObj),
          actualBarColor: getActualDateBarColor(task.result),
          actualBarBorderColor: '',
        }
        let assignee =
          task.assignments && task.assignments.length > 0
            ? {
                first_name: task.assignments[0].user.first_name,
                last_name: task.assignments[0].user.last_name,
                avatar: task.assignments[0].user?.avatar?.url_path,
              }
            : null
        ganttTasks.push({
          start: getDate(task.plan_start_date),
          end: getDate(task.plan_end_date),
          name: task.name,
          id: task.id,
          progress: task.progress,
          type: 'task',
          status: task.result,
          project: section.id,
          planStartDate: planStartDate,
          planEndDate: planEndDate,
          actualDate: task.actual_date,
          isPlanDateRange: task?.is_range_date,
          assignee,
          value: task.value,
          styles,
          displayOrder: i,
          actualStart: moment(task.actual_date).startOf('day').toDate(),
          actualEnd: moment(task.actual_date).endOf('day').toDate(),
          isTaskDone: isTaskDone,
        })
        i++
      }
      project.totalCompletedTask = doneTask
    }
    i++
  }

  return ganttTasks
}
